// extracted by mini-css-extract-plugin
export default {"root":"renderCase_root__I5-Lq"};